<template>
  <ProductCardStandaloneListing
    v-if="standalone"
    :products="configData?.Data"
    :header="configData?.Header"
    :default-plan-id="configData?.DefaultPlanId"
    :binding-period-in-months="configData?.BindingPeriodInMonths"
  />

  <ProductCardListing
    v-else
    :data="configData?.Data"
    :category-name="configData?.Category"
  />
</template>

<script lang="ts" setup>
import type { ListingProduct } from '~/models/ListingProduct.api.model';

interface Props {
  configData?: {
    Data: ListingProduct[];
    FamilyCard?: boolean | false;
    LinkCard?: boolean | false;
    Category?: string;
    Header?: string;
    DefaultPlanId?: number;
    BindingPeriodInMonths?: number;
  };
  standalone?: boolean;
}

withDefaults(defineProps<Props>(), {
  standalone: false,
  configData: undefined,
});
</script>
